module.exports = __webpack_public_path__ + "img/company.98ed45a5.png";